import { debugStore } from '@stores/Debug';
import Hls from 'hls.js';

/**
 * Returns whether HLS.js should be considered supported in the app.
 * When debug mode is on and "Mock non-support for HLS" is enabled, returns false
 * so you can test the unsupported (e.g. older iOS) flow without a real device.
 */
export function isHlsSupported(): boolean {
  if (debugStore.respectfulDebugMode && debugStore.mockHlsUnsupported) {
    return false;
  }
  return Hls.isSupported();
}
